import {Component, HostListener, OnInit} from '@angular/core';
import {StateService} from '@uirouter/core';
import {UIRouter} from "@uirouter/angular";

import {
    AppAlertService,
    AuthenticationService,
    ParametersService,
    SubtitlesService
} from '../core';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    externalLogin: string | null = null;
    logoSrc: string = '';
    logoName: string = '';
    showPassword = false;

    constructor(
        private appAlert: AppAlertService,
        public authentication: AuthenticationService,
        public parameters: ParametersService,
        private router: UIRouter,
        private $state: StateService,
        public subtitles: SubtitlesService
    ) {
    }

    ngOnInit(): void {
        this.externalLogin = this.router.globals.params['client_id'] ?? '';
        this.setCompanyLogo();
        this.parameters.showLoginBox = true;
    }

    togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
    }

    @HostListener('window:message', ['$event'])
    onPostMessage(message: MessageEvent) {
        if (!message.data) {
            return;
        }
        try {
            const messageData = JSON.parse(message.data);

            if (messageData.remote && messageData.username !== undefined) {
                this.authentication.username = messageData.username;
                this.authentication.remote = messageData.remote;
                this.authentication.login();
            }

            if (!messageData.remote && messageData.username !== undefined &&
                messageData.password !== undefined) {
                // messageData.origin === 'https://portaal.eplucon.nl' &&
                this.authentication.username = messageData.username;
                this.authentication.password = messageData.password;
                this.authentication.login();
            }
        } catch (e) {}
    }

    goForgotPassword() {
        return this.$state.go('forgotPassword', {});
    }

    loginDemoAccount(): void {
        let test: string;
        const company = this.parameters.urlCompany;

        if (this.authentication.username !== '' || this.authentication.password !== '') {
            const message = '<div class="text-align-center">' + this.subtitles.setSubtitle(1913) + '</div>';
            this.appAlert.showAppAlert(message, this.subtitles.setSubtitle(475), null, false, null);
        }

        if (company === 'polypipe' || company === 'oeg' || company === 'elias' || company === 'app' || company === 'jawo') {
            test = 'testl';
        } else {
            test = 'test';
        }

        this.authentication.username = test;
        this.authentication.password = test;
        this.authentication.login();
    }

    showDemoAccountButton(): boolean {
        const companies = ['klimor', 'roth', 'verano'];
        return !companies.includes(this.parameters.urlCompany);
    }


    subtitle(id: number): string {
        return this.subtitles.setSubtitle(id);
    }

    private setCompanyLogo(): void {
        switch (this.parameters.urlCompany) {
            case 'roth':
                this.logoName = 'roth';
                this.logoSrc = 'roth_red.svg';
                break;
            case 'polypipe':
                this.logoName = 'polypipe';
                this.logoSrc = 'logo_polypipe.png';
                break;
            case 'opop':
                this.logoName = 'opop';
                this.logoSrc = 'logo_opop.svg';
                break;
            case 'oeg':
                this.logoName = 'oeg';
                this.logoSrc = 'logo_oeg.png';
                break;
            case 'elias':
                this.logoName = 'elias';
                this.logoSrc = 'logo_elias.svg';
                break;
            case 'jawo':
                this.logoName = 'jawo';
                this.logoSrc = 'logo_jawo_red.png';
                break;
            case 'kolton':
                this.logoName = 'kolton';
                this.logoSrc = 'logo_kolton.png';
                break;
            case 'klimor':
                this.logoName = 'klimor';
                this.logoSrc = 'logo/logo-klimor.svg';
                break;
            case 'verano':
                this.logoName = 'verano';
                this.logoSrc = 'logo/VERANO_logo.svg';
                break;
            default:
                this.logoName = 'tech';
                this.logoSrc = 'logo_tech_vector_dark.svg';
        }
    }
}
